// @ts-nocheck
import { CREATE_ENGAGEMENT_ERROR, CREATE_ENGAGEMENT_LOADING, CREATE_ENGAGEMENT_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CreateEngagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_ENGAGEMENT_LOADING:
            return Object.assign({}, state, { loading: true })
        case CREATE_ENGAGEMENT_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CREATE_ENGAGEMENT_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}
